export const meta = {
  id: 'G01',
  slug: 'login',
  title: 'Como entrar no Personagrama',
  description: 'Use seu e-mail e senha para acessar o Personagrama depois da ativação da conta.',
  profile: 'student',
  category: 'acesso',
  type: 'task',
  status: 'published',
  order: 30,
  keywords: ['login', 'entrar', 'acesso', 'email', 'senha'],
  previous: 'G02',
  next: 'G03',
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como entrar no Personagrama

Depois que sua conta estiver ativa, o acesso é feito pela tela de login.

## Como fazer

<Steps>
  <Step title="Informe seu e-mail">
    Use o mesmo e-mail associado ao seu acesso ao Personagrama.
  </Step>
  <Step title="Digite sua senha">
    Informe sua senha pessoal.
  </Step>
  <Step title="Selecione Entrar">
    Aguarde a autenticação. Quando ela for concluída, você será direcionado para sua área.
  </Step>
</Steps>

<HelpImage alt="Tela de login do Personagrama" pendingId="G01.1" />

## Depois do login

Para o Aluno, a referência principal é a tela **Hoje**. Ela apresenta as ações mais relevantes conforme seu momento de desenvolvimento.

<Callout type="tip">
  Se você não lembrar sua senha, utilize a opção de recuperação disponível na própria tela de login.
</Callout>
